import axios from "axios";
import config from "../config";
// import jwtDecode from 'jwt-decode';

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = config.BASE_URL;

const AUTH_SESSION_KEY = "auth_token";
const jwtDecode = require('jwt-decode').jwtDecode;
let axiosResponseInterceptorId: number | null = null;

/**
 * Sets the default authorization
 * @param {*} token
 */

class APICore {

 setAuthorization = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};


getEmailFromToken = () => {
  const token = this.getLoggedInUser();
  if (!token) return null;
  try {
      const decoded: any = jwtDecode(token);
      return decoded.email;
  } catch (error) {
      console.warn("Error decoding the token:", error);
      return null;
  }
}

 handleTokenExpiration = () => {
  localStorage.removeItem(AUTH_SESSION_KEY);
  window.location.href = '/';
};


  /* Fetches data from given url*/
  get = async (url: string, params: any) => {
    try {
      const response = await axios.get(url, { params });
      
      return response;
    } catch (error) {
      throw error; 
    }
};

  getFile = (url: string, params: any) => {
    let response;
    if (params) {
      var queryString = params
        ? Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&")
        : "";
      response = axios.get(`${url}?${queryString}`, { responseType: "blob" });
    } else {
      response = axios.get(`${url}`, { responseType: "blob" });
    }
    return response;
  };

  getMultiple = (urls: string, params: any) => {
    const reqs = [];
    let queryString = "";
    if (params) {
      queryString = params
        ? Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&")
        : "";
    }

    for (const url of urls) {
      reqs.push(axios.get(`${url}?${queryString}`));
    }
    return axios.all(reqs);
  };

  /* post given data to url*/
  create = async (url: string, data: any) => {
    try {
      const response = await axios.post(url, data);
      return response;
    } catch (error) {
      throw error; 
    }
  };

  createWithoutAuth = async (url: string, data: any) => {
    try {
      delete axios.defaults.headers.common["Authorization"];
      const response = await axios.post(url, data);
      return response;
    } catch (error) {
      throw error; 
    }
  };

  /* Updates patch data*/
  updatePatch = async (url: string, data: any) => {
    try {
      const response = await axios.patch(url, data);
      return response;
    } catch (error) {
      throw error; 
    }
  };
  /* Updates data*/
  update = async (url: string, data: any) => {
    try {
      const response = await axios.put(url, data);
      return response;
    } catch (error) {
      throw error; 
    }
  };

  /* Deletes data*/
  delete = async (url: string) => {
    try {
      const response = await axios.delete(url);
      return response;
    } catch (error) {
      throw error; 
    }
  };


  /* post given data to url with file*/
  createWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }

    const config = {
      headers: {
        ...axios.defaults.headers,
        "content-type": "multipart/form-data",
      },
    };
    return axios.post(url, formData);
  };

  /* post given data to url with file */
  updateWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }

    const config = {
      headers: {
        ...axios.defaults.headers,
        "content-type": "multipart/form-data",
      },
    };
    return axios.patch(url, formData);
  };

  isUserAuthenticated = () => {
    const token = this.getLoggedInUser();
    if (!token) {
      return false;
    }
    try {
      const decoded: any = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        console.warn("Access token expired");
        localStorage.removeItem('token');
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.warn("Error decoding the token:", error);
      return false;
    }
};

  setLoggedInUser = (token: string) => {
    localStorage.setItem(AUTH_SESSION_KEY, token);
  };

  /* Returns the logged in user*/
  getLoggedInUser = () => {
    return localStorage.getItem(AUTH_SESSION_KEY);
  };
  setUserInSession = (modifiedUser: any) => {
    const token = localStorage.getItem(AUTH_SESSION_KEY);
  if (token) {
    this.setLoggedInUser(token);
  }
  };
}
const api = new APICore();

// Global Axios response interceptor:
// - Automatically logs out on 401 responses (or known token-expired message)
// - Keeps behavior consistent across all API calls (including ones not using APICore wrappers)
if (axiosResponseInterceptorId !== null) {
  axios.interceptors.response.eject(axiosResponseInterceptorId);
}
axiosResponseInterceptorId = axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    if (status === 401 || message === 'Invalid or Expired Token') {
      api.handleTokenExpiration();
    }

    return Promise.reject(error);
  }
);

  // Check if token is available in local storage
  const token = localStorage.getItem(AUTH_SESSION_KEY);
  if (token) {
    api.setAuthorization(token);
  }


export { api, APICore as default };